export default __webpack_public_path__ + "static/media/follow-portal.ae026989.webp";